import request from '@/utils/request';

export const messageApi = {
  messageList (params) {
    return request({
      url: '/message/list',
      method: 'get',
      params
    });
  },
  // 最新（未发送消息）
  taskMessageNewest () {
    return request({
      url: '/message/to_sent',
      method: 'get'
    });
  },
  // 简要消息
  messageBrief () {
    return request({
      url: '/message/brief',
      method: 'get'
    });
  },
  // 消息详情
  messageDetail (params) {
    return request({
      url: '/message/detail',
      method: 'get',
      params
    });
  },
  // 设置已读
  messageRead (data) {
    return request({
      url: '/message/read',
      method: 'put',
      data
    });
  },
  // 设置全部已读
  messageReadAll () {
    return request({
      url: '/message/read/all',
      method: 'put'
    });
  },
  // 删除消息
  message (data) {
    return request({
      url: '/message',
      method: 'DELETE',
      data
    });
  },
  // 删除全部消息
  messageAll () {
    return request({
      url: '/message/all',
      method: 'DELETE'
    });
  }
};



// WEBPACK FOOTER //
// ./src/api/workbench/message.js